module.exports = __webpack_public_path__ + "media/application/images/fields-88e56ddce4dfd5d5b370ad73511dfb71.jpeg";